import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../services/auth.service';
@Component({
  selector: 'app-user-create',
  templateUrl: './user-create.component.html',
  styleUrls: ['./user-create.component.css']
})
export class UserCreateComponent implements OnInit {
  userForm!: FormGroup;
  roles = ['customer', 'provider'];
  userService: AuthService | undefined;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.userForm = this.fb.group({
      id: [null, Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      token: [''],
      userBadge: ['', Validators.required],
      balance: [0, Validators.required],
      email: ['', [Validators.required, Validators.email]],
      role: ['customer', Validators.required],
      address: [''],
      serviceArea: [[]],
      services: [[]],
      rating: [null],
      profileImage: [''],
      referredBy: ['', Validators.required],
          // other fields...
      serviceAreaText: [''], // helper text input 
      
      servicesText: [''], // helper text input 
    });
  }

  updateServiceArea() {
    const text = this.userForm.get('serviceAreaText')?.value || '';
    const array = text.split(',').map((x: string) => x.trim()).filter((x: any) => x);
    this.userForm.get('serviceArea')?.setValue(array);
  }

   updateServices() {
    const text = this.userForm.get('servicesText')?.value || '';
    const array = text.split(',').map((x: string) => x.trim()).filter((x: any) => x);
    this.userForm.get('services')?.setValue(array);
  }
  onSubmit() {
    if (this.userForm.valid) {
      console.log('User created:', this.userForm.value);
      // TODO: send to backend service


      const formValue = this.userForm.getRawValue(); // includes disabled controls if any

      // Optional: clean or transform helper text fields before sending
      // formValue.serviceArea = this.splitText(formValue.serviceAreaText);
      // formValue.services = this.splitText(formValue.servicesText);

      this.userService?.createUser(formValue).subscribe({
        next: response => console.log('User created!', response),
        error: err => console.error('Error creating user', err)
      });
    } 
  }
}